// all analytics track calls should be linked to a constant here

export const TRACK_FE_PERFORMANCE_DURATION = "FE Performance Duration";

export const TRACK_SIGN_UP_INVITE_ONLY_ERROR =
  "Sign Up Missing Invitation Occurred";
export const TRACK_SIGN_UP_HELP = "Sign Up Failure Form Submitted";
